@if (loaded && agents.length > 0) {
  <div class="automations-preview-wrapper">
    <button class="automations-chip native-chip" (click)="toggle()">
      <tidy-ai-loader class="automations-swirl" />
      <tidy-text [headerButton]="buttonText" />
    </button>
    @if (isOpen) {
      <div class="automations-dropdown">
        @for (agent of agents; track agent.id) {
          <button class="automation-card" (click)="goToAutomation(agent)">
            <div class="automation-name">
              <span
                class="agent-status-icon"
                [class.disabled]="!agent.enabled"
                [title]="agent.enabled ? ('Enabled' | translate) : ('Disabled' | translate)"></span>{{ agent.name }}
            </div>
          </button>
        }
      </div>
    }
  </div>
}
